export const REVIEWS_API_URL = "https://backend.einsured.ca/wp-json/api/v1/ei/reviews";

export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/place/einsured.ca+-+Life+Insurance+%7C+Super+Visa+Insurance/@43.7579458,-79.6924803,17z/data=!3m1!4b1!4m6!3m5!1s0x882b355459104fed:0x843a7824e45478c4!8m2!3d43.7579458!4d-79.6924803!16s%2Fg%2F11h70rsb9c?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D";

const toNum = (v, fb = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : fb;
};

export async function fetchReviews({ page = 1, perpage = 15, signal } = {}) {
  const url = `${REVIEWS_API_URL}?page=${page}&perpage=${perpage}`;

  const res = await fetch(url, {
    method: "GET",
    headers: { Accept: "application/json" },
    signal,
  });

  if (!res.ok) {
    throw new Error(`Reviews API error: ${res.status}`);
  }

  const json = await res.json();

  const list = Array.isArray(json)
    ? json
    : Array.isArray(json?.data)
    ? json.data
    : [];

  const total = json?.pagination
    ? json.pagination.total
    : 15;

  const reviews = list
    .map((r, idx) => ({
      id: r?.id ?? `${page}-${idx}`,
      author: r?.author_name ?? "Anonymous",
      rating: toNum(r?.rating, 0),
      text: (r?.text ?? "").trim(),
      avatar: r?.profile_photo_url ?? "",
      timeUnix: toNum(r?.time, 0),
      date: r?.time ? new Date(toNum(r.time, 0) * 1000) : null,
    }))
    .sort((a, b) => (b.timeUnix || 0) - (a.timeUnix || 0));

  return {
    reviews,
    hasMore: list.length === perpage,
    page,
    perpage,
    total
  };
}
